// extracted by mini-css-extract-plugin
export default {"separator":"bQU8p9RpfabH13zmqCU9"};